import IPolicyEditorState from "system/types/store/IPolicyEditorState";

const policyEditorState: IPolicyEditorState = {
  licenseFileValid: true,
  rules: [],
  selectedPackage: null,
  modifiedRows: [],
  packages: [],
  globalCatalog: [],
  pendingReplicateChanges: { additions: [], removals: [] },
  initialPendingReplicateChanges: { additions: [], removals: [] },
  lastEditedIndex: null,
  configurationByPackage: {},
  invalidRules: [],
  clientConfig: [],
  clientConfigModified: false,
  inheritedConfigurations: [],
  sitesAndSubnets: [],
  systemConfigurations: [],
  invalidConfigs: [],
  activeDirectoryDomains: [],
  activeDirectoryOUs: [],
  currentVersionId: null,
  pendingConfigSections: null,
};

export default policyEditorState;
